import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SessionService } from './session.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthenticationGuard implements CanActivate {
  constructor(private session: SessionService, private router: Router) {
    //verificamos si existen variables de session para permitir el reload
    this.session.realodSession().then(data =>{
      if(data){
        // no hacemos nada y permitimos el reload
      }else{
        sessionStorage.clear();
        this.router.navigate(['/']);
      }
    })
   }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.session.getLoggedIn()) {
      return true;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }
}
